import * as React from 'react';
import * as styles from './styles.css';

import { Text } from '../../Text';

export interface IListItemProps {
  title: string;
  afterTitle?: string;
  subTitle: string;
  list: string[];
  icon: React.ReactElement;
}

export function ListItem({ title, afterTitle, subTitle, list, icon }: IListItemProps) {
  return (
    <div className={styles['item']}>
      {icon}
      <div className={styles['item-title']}>
        <Text size="h4" bold>
          {title}
        </Text>
        {afterTitle && (
          <>
            {' '}
            <Text color="gray">*</Text>
          </>
        )}
      </div>
      <div className={styles['item-subtitle']}>
        <Text color="gray">{subTitle}</Text>
      </div>
      <div className={styles['custom-list']}>
        {list.map((listItem, index) => {
          return (
            <div key={index}>
              <Text>{listItem}</Text>
            </div>
          );
        })}
      </div>
    </div>
  );
}
